import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { COLORS, FONT_FAMILY } from '../constants/styles';
import Icon from './Icon';
import Spinner from './Spinner';
import { TranslationHelpers } from '../../../i18n/translationHelpers';

interface IButtonOutlineProps extends React.HTMLAttributes<HTMLButtonElement> {
    id: string;
    text: any;
    type?: 'button' | 'submit' | undefined;
    onClick: any;
    icon?: string[];
    loading?: boolean;
    disabled?: boolean;
}

const ButtonBase = styled.button`
    align-items: center;
    background-color: transparent;
    border: solid 1px ${COLORS.dark1};
    border-radius: 4px;
    color: ${({ color }) => (color ? color : `${COLORS.dark1}`)};
    border-color: ${({ color }) => (color ? color : `${COLORS.dark1}`)};
    display: flex;
    ${FONT_FAMILY.multipleRegularCss};
    font-size: 1rem;
    font-weight: 300;
    justify-content: center;
    line-height: 1;
    margin: auto;
    min-width: 100px;
    overflow-wrap: break-word;
    opacity: 1;
    padding: 15px;
    transition: opacity 0.1s;
    word-break: break-word;

    &:hover {
        cursor: pointer;
        opacity: 0.8;
    }

    &:hover &:disabled,
    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    svg {
        margin-right: 10px;
        height: 20px;
    }
`;

const ButtonOutline = ({
    id,
    text,
    type = 'button',
    icon,
    onClick,
    loading,
    disabled,
    ...rest
}: IButtonOutlineProps) => (
    <ButtonBase id={id} onClick={onClick} type={type} disabled={disabled} {...rest}>
        {loading && <Spinner size={15} color={COLORS.white} />}
        {!loading && icon && <Icon icon={icon} />}
        {!loading && TranslationHelpers.getFormattedMessage(text.id)}
    </ButtonBase>
);

export default ButtonOutline;
